import HighchartsReact from "highcharts-react-official";
import { SkeletonContainer } from "../Loader/Loader";
import Highcharts from "highcharts";
import { useTimeSpentTask } from "../../Hooks/Features/ProjectDashboard/useTimeSpentTask";
import { Dropdown } from "primereact/dropdown";

const TimeSpentTask = ({ projectOpts }) => {
    const { chartData, loader, getTaskTimeSpentData, filter, setFilter, categoryOptions } = useTimeSpentTask({ projectOpts });


    const options = {
        credits: { enabled: false },
        chart: { type: 'column' },
        title: {
            text: '',
            align: 'center'
        },
        xAxis: {
            categories: chartData?.xAxis
        },
        yAxis: {
            min: chartData?.min || 0,
            max: chartData?.max || 1000,
            title: { text: 'Hours' },
            tickInterval: chartData?.tickInterval
        },
        legend: {
            verticalAlign: 'top',
            reversed: true
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true
                }
            }
        },
        series: chartData?.data
    };



    return (
        <div className="w100 my-2 card-container" style={{ height: "100%" }} title="Time Spent by Task and Status (in hours)">
            <div className='d-flex justify-content-between'>
                <span style={{ fontSize: "14px", fontWeight: "600" }}> Time Spent by Task and Status</span>
                <div className='w20'>
                    <Dropdown
                        onChange={(e) => setFilter((prev) => ({ ...prev, categoryType: e.value, isChange: true }))}
                        options={categoryOptions}
                        filter
                        filterInputAutoFocus
                        placeholder="X Axis"
                        value={filter?.categoryType}
                        optionLabel="category_name"
                        onHide={() => { if (filter?.isChange) getTaskTimeSpentData() }}
                        name="categoryType"
                    />
                </div>
            </div>
            <div style={{ height: "95%" }}>
                {
                    loader ? <div style={{ height: "inherit" }}>
                        <SkeletonContainer />
                    </div> :
                        chartData?.data?.length > 0 ?
                            <HighchartsReact highcharts={Highcharts} options={options} containerProps={{
                                style: {
                                    height: "inherit",
                                },
                            }} /> : <div className="w100 d-flex justify-content-center align-items-center" style={{ height: "inherit" }}>
                                <div className='text-center'>
                                    <img src={"./assets/nodata.jpg"} alt='no data' />
                                    <p className=' red mt-3'> Data Not Found</p>
                                </div>
                            </div>
                }
            </div>
        </div>
    )
}

export default TimeSpentTask